{
  "status": {
    "pending": "Chờ kết quả",
    "preliminary": "Sơ bộ",
    "final": "Chính thức",
    "corrected": "Đã hiệu chỉnh",
    "amended": "Đã bổ sung",
    "addended": "Có phụ lục",
    "enteredInError": "Nhập sai",
    "unknown": "Không rõ"
  },
  "review": {
    "title": "Xem Kết Quả",
    "printLabel": "In kết quả",
    "summary": {
      "count_one": "{{count}} kết quả",
      "count_other": "{{count}} kết quả",
      "criticalUnacknowledged": "{{count}} giá trị nguy kịch chưa xác nhận"
    },
    "view": {
      "timeline": "Dòng thời gian",
      "flowsheet": "Bảng theo dõi"
    },
    "filter": {
      "date": "Ngày",
      "type": "Loại",
      "status": "Trạng thái",
      "statusAll": "Tất cả"
    },
    "dateRange": {
      "h24": "24 giờ qua",
      "h48": "48 giờ qua",
      "d7": "7 ngày qua",
      "d30": "30 ngày qua",
      "all": "Tất cả"
    },
    "resultType": {
      "all": "Tất cả",
      "lab": "Xét nghiệm",
      "imaging": "Chẩn đoán hình ảnh",
      "pathology": "Giải phẫu bệnh",
      "cardiology": "Tim mạch",
      "microbiology": "Vi sinh"
    },
    "criticalOnlyToggle": "Chỉ giá trị nguy kịch",
    "criticalBadge": "NGUY KỊCH",
    "actions": {
      "acknowledgeCritical": "Xác nhận nguy kịch",
      "acknowledgeAllCritical": "Xác nhận tất cả kết quả nguy kịch ({{count}})"
    },
    "detail": {
      "resultNumber": "Mã kết quả",
      "performingProviderId": "Mã bác sĩ thực hiện",
      "verifiedByProviderId": "Mã bác sĩ xác nhận",
      "verifiedAt": "Thời gian xác nhận",
      "specimenCollected": "Thời gian lấy mẫu",
      "clinicalSignificance": "Ý nghĩa lâm sàng",
      "recommendations": "Khuyến nghị",
      "report": "Báo cáo",
      "addendum": "Phụ lục",
      "criticalAcknowledged": "Giá trị nguy kịch đã xác nhận",
      "providerHash": "Bác sĩ #{{id}}",
      "acknowledgedAt": " lúc {{when}}",
      "specimenType": "Loại bệnh phẩm",
      "grossDescription": "Mô tả đại thể",
      "microscopicDescription": "Mô tả vi thể",
      "accessionNumber": "Số tiếp nhận",
      "bodyRegion": "Vùng cơ thể",
      "studyInstanceUid": "Study Instance UID",
      "cardiologyMeasurements": "Các chỉ số đo",
      "heartRate": "HR",
      "prInterval": "PR",
      "qrsDuration": "QRS",
      "qtInterval": "QT",
      "qtcInterval": "QTc",
      "ejectionFraction": "EF"
    },
    "loading": "Đang tải kết quả…",
    "loadError": "Không tải được kết quả. Vui lòng thử lại.",
    "empty": "Không có kết quả nào phù hợp với bộ lọc đã chọn.",
    "toast": {
      "acknowledgeSuccess": "Đã xác nhận giá trị nguy kịch",
      "acknowledgeError": "Xác nhận kết quả thất bại"
    },
    "susceptibility": {
      "title": "Vi khuẩn và độ nhạy cảm",
      "antibiotic": "Kháng sinh",
      "interpretation": "Diễn giải",
      "mic": "MIC",
      "unnamedOrganism": "Vi khuẩn chưa định danh",
      "noPanel": "Không có kết quả kháng sinh đồ cho vi khuẩn này."
    },
    "components": {
      "value": "Giá trị",
      "referenceRange": "Khoảng tham chiếu"
    }
  },
  "pending": {
    "title": "Kết Quả Chờ",
    "countBadge_one": "{{count}} đang chờ",
    "countBadge_other": "{{count}} đang chờ",
    "autoRefresh": "Tự động làm mới {{seconds}}s",
    "updated": "Cập nhật {{when}}",
    "searchPlaceholder": "Tìm theo tên bệnh nhân, MRN, hoặc y lệnh…",
    "filtersButton": "Bộ lọc",
    "fields": {
      "orderType": "Loại Y Lệnh",
      "allTypes": "Tất cả loại",
      "priority": "Mức Ưu Tiên",
      "allPriorities": "Tất cả mức ưu tiên",
      "dateFrom": "Từ ngày",
      "dateTo": "Đến ngày"
    },
    "orderType": {
      "lab": "Xét nghiệm",
      "imaging": "Chẩn đoán hình ảnh",
      "procedure": "Thủ thuật",
      "consultation": "Hội chẩn",
      "laboratory": "Xét nghiệm",
      "radiology": "X-quang",
      "surgery": "Phẫu thuật",
      "therapy": "Trị liệu",
      "medication": "Thuốc",
      "admission": "Nhập viện"
    },
    "aria": {
      "dateFrom": "Kết quả chờ từ ngày",
      "dateTo": "Kết quả chờ đến ngày"
    },
    "columns": {
      "patient": "Bệnh nhân",
      "mrn": "MRN",
      "order": "Y lệnh",
      "type": "Loại",
      "orderedBy": "Bác sĩ ra y lệnh",
      "ordered": "Thời gian ra",
      "expected": "Thời gian dự kiến",
      "priority": "Ưu tiên"
    },
    "loading": "Đang tải kết quả chờ…",
    "loadError": "Không tải được kết quả chờ",
    "retry": "Thử lại",
    "empty": "Không có kết quả chờ.",
    "awaitingResult": "Đang chờ kết quả",
    "specimenReceived": "Đã nhận mẫu",
    "inLab": "Đang xét nghiệm",
    "cancelledByLab": "Phòng xét nghiệm đã hủy",
    "overdue": "Quá hạn",
    "expectedBy": "Dự kiến trước {{date}}"
  },
  "critical": {
    "title": "Kết Quả Nguy Kịch",
    "autoRefresh": "Tự động làm mới {{seconds}}s",
    "updated": "Cập nhật {{when}}",
    "unacknowledgedHeading_one": "{{count}} giá trị nguy kịch chưa xác nhận",
    "unacknowledgedHeading_other": "{{count}} giá trị nguy kịch chưa xác nhận",
    "escalationBanner": "Các kết quả này cần được bác sĩ xác nhận ngay.",
    "acknowledgeWithinMinutes": "Xác nhận trong vòng {{minutes}} phút",
    "routeBackToProvider": "Trả về bác sĩ ra y lệnh",
    "attendingSignoff": "Cần bác sĩ điều trị ký xác nhận",
    "searchPlaceholder": "Tìm theo bệnh nhân hoặc tên xét nghiệm…",
    "showAcknowledgedToggle": "Hiện đã xác nhận",
    "escalationTime": "T+{{minutes}}ph",
    "criticalFallback": "NGUY KỊCH",
    "loading": "Đang tải kết quả nguy kịch…",
    "loadError": "Không tải được kết quả nguy kịch",
    "empty": "Không có kết quả nguy kịch chờ xác nhận.",
    "detailToggleLabel": "Hiện chi tiết kết quả",
    "openFullChart": "Mở bệnh án đầy đủ",
    "columns": {
      "patient": "Bệnh nhân",
      "mrn": "MRN",
      "test": "Xét nghiệm",
      "value": "Giá trị",
      "impression": "Nhận định",
      "resultTime": "Thời gian kết quả",
      "escalation": "Thời gian leo thang",
      "acknowledged": "Đã xác nhận",
      "actions": "Thao tác"
    },
    "actions": {
      "acknowledge": "Xác nhận"
    },
    "toast": {
      "acknowledgeSuccess": "Đã xác nhận giá trị nguy kịch",
      "acknowledgeError": "Xác nhận kết quả thất bại"
    },
    "refreshFailed": "Không thể làm mới — đang hiển thị kết quả nguy kịch tính đến {{when}}.",
    "incomplete": "Đang hiển thị {{shown}} trên {{total}} kết quả nguy kịch. Danh sách này chưa đầy đủ."
  },
  "acknowledged": {
    "pending": "Chờ xác nhận",
    "acknowledged": "Đã xác nhận",
    "escalated": "Đã leo thang",
    "expired": "Hết thời hạn xác nhận"
  },
  "flowsheet": {
    "analyte": "Chỉ số xét nghiệm",
    "empty": "Không có chỉ số xét nghiệm để theo dõi",
    "emptyHint": "Báo cáo hình ảnh, giải phẫu bệnh và vi sinh hiển thị ở chế độ dòng thời gian.",
    "trend": {
      "toggle": "Xu hướng {{analyte}}",
      "referenceRange": "Tham chiếu {{range}}",
      "nonNumericOmitted_one": "{{count}} kết quả dạng chữ không được vẽ",
      "nonNumericOmitted_other": "{{count}} kết quả dạng chữ không được vẽ"
    }
  }
}
